export const WORKFLOW_STATUS_QUOTING = 'QUOTING' // if the QUOTING job aren't already COMPLETED
export const WORKFLOW_STATUS_TRANSLATION = 'TRANSLATION' // if the QUOTING job are COMPLETED
export const WORKFLOW_STATUS_REVISION = 'REVISION - LQA' // if the TRANSLATION job are COMPLETED
export const WORKFLOW_STATUS_CLIENT_REVIEW = 'CLIENT REVIEW - LQA' // if the REVISION - LQA job are COMPLETED
export const WORKFLOW_STATUS_SIGN_OFF = 'SIGN-OFF' // if the CLIENT REVIEW - LQA job are COMPLETED
export const WORKFLOW_STATUS_CANCELLED = 'CANCELLED' // if all job are CANCELLED
export const WORKFLOW_STATUS_COMPLETED = 'COMPLETED' // if all job are COMPLETED or DELIVERED
export const WORKFLOW_STATUS_FINANCIAL_APPROVAL = 'FINANCIAL APPROVAL'
export const WORKFLOW_STATUS_EDITING = 'EDITING'
export const WORKFLOW_STATUS_REVIEW = 'REVIEW'
export const WORKFLOW_STATUS_COMPLETED_PROJECT = 'Completed'
export const WORKFLOW_STATUS_COMINGDUE_PROJECT = 'Coming Due'
export const WORKFLOW_STATUS_INPROGRESS_PROJECT = 'In Progress'
export const WORKFLOW_STATUS_PASTDUE_PROJECT = 'Past Due'
